import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/progressive-web/banner-pwa.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              {/* <h1 className="web_head_banner">Build Scalable Cloud Apps</h1> */}
              <h1 style={{ marginBottom: "10px" }}>
                Discover New Prospects for App Development with{" "}
                <span style={{ color: "#F47a14" }}>TekRevol’s</span> PWAs
              </h1>
              <p>
                From devising a unique mobile app to tapping into the world of
                the web, TekRevol is a leading progressive web app development
                company in developing unique PWAs tailored to your business
                needs. Our PWAs have the capabilities to give you the ideal
                in-app experiences across different platforms with guaranteed
                reach on the web.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Book a Consultation Today
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
